import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwarePlanCalendarRoute: InvariantJiraRoute = {
	name: 'software-plan-calendar',
	path: '/jira/plans/:planId/scenarios/:scenarioId/calendar',
};
